import React, { Component } from 'react';

import './index.scss';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSponsors: false
    }
  }
  toggleSponsors = () => {
    this.setState(prevState => {
      return {
        showSponsors: !prevState.showSponsors
      }
    })
  }
  render() {
    const { homepage } = this.props;
    return (
      <div className="footer">
        <div className="container -horizon-padding">
          <div className="row">
            <h3 className="title">about us</h3>
            <a href="https://www.facebook.com/simpleinfo/" target="_blank"><img src="/content-img/footer-simpleinfo.png" alt="" width="113px" height="70px" className=""/></a>

          </div>
          <div className="row">
            <h3 className="title">credit</h3>
            {
              homepage &&
              homepage.footer_credit &&
              <p className="text">{homepage.footer_credit}</p>
            }
          </div>
          <div className="row">
            <h3 className="title">thank you</h3>
            {
              homepage &&
              homepage.footer_sponsor_info &&
              <div className="text" dangerouslySetInnerHTML={{__html: homepage.footer_sponsor_info}}></div>
            }
            <p className="text">贊助人名單</p>

            {
              homepage &&
              homepage.footer_sponsor_list &&
              <div className={`text sponsors ${this.state.showSponsors ? '-active' : ''}`}>
                <textarea name="" id="" rows="6" readOnly value={homepage.footer_sponsor_list}></textarea>
              </div>
            }
            <img src="/content-img/arrow-down.svg" alt="" className={`arrow-down ${this.state.showSponsors ? '-active' : ''}`} onClick={this.toggleSponsors}/>

          </div>
          <div className="row">
            <h3 className="title">support</h3>
            {
              homepage &&
              homepage.footer_support_us &&
              <div className="text" dangerouslySetInnerHTML={{__html: homepage.footer_support_us}}></div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/pure.js